document.addEventListener("DOMContentLoaded", () => {
    const sectionsPurple = document.querySelectorAll('.section_purple');

    const sectionObserver = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            const section = entry.target;

            if (!entry.isIntersecting) return;
            if (section.dataset.animated === "true") return;

            const lines = section.querySelectorAll('.line_green');

            lines.forEach((el, index) => {
                setTimeout(() => {
                    el.classList.add('show');
                }, index * 200);
            });

            section.dataset.animated = "true";
            obs.unobserve(section);
        });
    }, {
        threshold: 1
    });

    sectionsPurple.forEach(section => sectionObserver.observe(section));

});

document.addEventListener('DOMContentLoaded', function () {

    const header = document.querySelector('.header');
    const headerTop = document.querySelector('.header__top');

    if (!header || !headerTop) return;

    if (window.innerWidth > 768) return;

    const topHeight = headerTop.offsetHeight;

    function updateHeader() {

        const navContainer = document.querySelector(
            'nav.hc-offcanvas-nav.hc-nav-1 .nav-container'
        );

        if (window.scrollY > 0) {
            header.style.transform = `translateY(-${topHeight}px)`;
            navContainer?.classList.add('header__top-hidden');
        } else {
            header.style.transform = 'translateY(0)';
            navContainer?.classList.remove('header__top-hidden');
        }
    }

    updateHeader(); // état initial
    window.addEventListener('scroll', updateHeader);

});
